import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import toast from 'react-hot-toast'

import styles from './AccountSettings.module.css'

import FormControl from 'Design/components/FormControl'
import Label from 'Design/components/Label'
import Input from 'Design/components/Input'
import Button from 'Design/components/Button'
import FormErrorText from 'Design/components/FormErrorText'
import PageLoader from 'Layout/PageLoader'

import { AuthorizedPage } from '../../../../components/Authorized'

import { useGetAccountQuery, useUpdateAccountMutation } from 'Services/account'
import accountFormValidationSchema from './account-form-validation-schema'

const AccountSettings = (props) => {
  const { account } = props

  const {
    register,
    formState: { errors, isDirty, isSubmitSuccessful },
    handleSubmit,
    reset,
    getValues
  } = useForm({
    defaultValues: {
      companyName: account.company_name
    },
    resolver: yupResolver(accountFormValidationSchema)
  })

  const [updateAccount, updateAccountResult] = useUpdateAccountMutation()

  const handleFormSubmit = (data) => {
    const payload = {
      company_name: data.companyName
    }

    const promise = updateAccount(payload).unwrap()
    toast.promise(promise, {
      loading: 'Updating account details',
      success: 'Account info updated successfully',
      error: 'Error while updating account details. Try again.'
    })

    return promise
  }

  useEffect(() => {
    if (!isSubmitSuccessful) {
      return
    }

    reset({ ...getValues() })
  }, [isSubmitSuccessful, reset, getValues])

  const disableSaveButton = updateAccountResult.isLoading || !isDirty

  return (
    <div className={styles.Container}>
      <form onSubmit={handleSubmit(handleFormSubmit)} className={styles.Form}>
        <FormControl isInvalid={errors.companyName}>
          <Label>Company name</Label>
          <Input {...register('companyName')} />
          {errors.companyName && <FormErrorText>{errors.companyName.message}</FormErrorText>}
        </FormControl>

        <Button variant='primary' type='submit' disabled={disableSaveButton}>
          Save
        </Button>
      </form>
    </div>
  )
}

const AccountSettingsContainer = () => {
  const { data: account = {}, isLoading } = useGetAccountQuery(null)

  if (isLoading) {
    return <PageLoader />
  }

  return <AccountSettings account={account} />
}

export default AuthorizedPage(AccountSettingsContainer, ['account_settings_modify'])
